<div
  [ngClass]="{ 'preview-media-out': messageSource, 'preview-media-in': !messageSource }"
  #divElement
  >
  @if (messageSource) {
    <app-read-receipt class="read-receipt" [messageStatus]="content['messageStatus']"></app-read-receipt>
  }
  <video class="preview-media-display" #videoElement>
    <source [src]="getVideoImage()" [type]="content['type']" />
  </video>
  <div class="preview-message-caption">{{ previewCaption }}</div>
  <div (click)="previewImage($event)" class="overlay"></div>
  <div (click)="previewImage($event)" class="image">
    <img src='../../../../../../../assets/svg/Play.svg' class="play-image" />
  </div>
</div>

<ng-template #previewVideoModule>
  <div class="preview-image-container">
    <div class="preview-image-header">
      <div class="preview-video-caption">
        <div class="text">{{ previewCaption }}</div>
      </div>
      <button class="preview-image-closeBtn" (click)="onClosePreview()"></button>
    </div>
    <div class="preview-image-body">
      <video id="videoPlayer" class="preview-image" width="800" height="480" controls>
        <source
          [src]="this.sanitization.bypassSecurityTrustUrl(content['src'])"
          [type]="content['type']"
          />
        </video>
      </div>
    </div>
  </ng-template>
